export default "__VITE_ASSET__5a6d4b8a__"